module.exports = __webpack_public_path__ + "img/TruPath-1.35a211f6.jpg";